import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Form, Field } from 'redux-form'
import Button from 'components/common/Button/Button'
import Input from './Input'

const ApplyCouponForm = ({
  handleSubmit,
  viewModel,
  submitting
}) =>
  <Form onSubmit={ handleSubmit }>
    <Field
      { ...viewModel.applyCoupon }
      component={ Input } />
    <AlignedButton data-at-apply-coupon-button disabled={ submitting }>Apply</AlignedButton>
  </Form>

ApplyCouponForm.propTypes = {
  asyncValidating: PropTypes.bool,
  handleSubmit: PropTypes.func,
  submitting: PropTypes.bool,
  viewModel: PropTypes.shape({
    applyCoupon: PropTypes.shape()
  })
}

export default ApplyCouponForm

const AlignedButton = styled(Button)`
  margin-top: -17px;
  padding: 7px 15px 8px;
`
